import { Module } from 'vuex';

import { RootState } from '@/store/types';

import activityRuleViolations from '../activityRuleViolations/store';
import rules from '../rules/store';
import actions from './actions';
import getters from './getters';
import initialState from './initialState';
import mutations from './mutations';
import { RuleCheckState } from './types';

const vuexModule: Module<RuleCheckState, RootState> = {
  namespaced: true,
  state: initialState() as RuleCheckState,
  mutations,
  actions,
  getters,
  modules: { rules, activityRuleViolations },
};

export default vuexModule;
